import React, { useState } from 'react';
import xw from 'xwind';
import styled from '@emotion/styled';
import { AnimatePresence, motion } from 'framer-motion';

interface SpecialCardAccordionProps {
  id: number | string;
  children: React.ReactNode;
}

type ToggleType = {
  toggle: boolean;
};

const Button = styled.button(({ toggle }: ToggleType) => [
  xw`focus:outline-none mt-4`,
  toggle ? xw`text-gray-300` : xw`text-active`,
]);

const SpecialCardAccordion = ({
  id,
  children,
}: SpecialCardAccordionProps): JSX.Element => {
  const [toggle, setToggle] = useState(false);

  function setToggleDescription() {
    setToggle((prev) => !prev);
  }

  function renderButton() {
    const text = toggle ? 'Close' : 'Read more';
    return (
      <Button toggle={toggle} onClick={() => setToggleDescription()}>
        {text}
      </Button>
    );
  }

  return (
    <>
      <AnimatePresence>
        <motion.div
          key={id}
          style={{ height: '130px', overflow: 'hidden' }}
          initial="closed"
          transition={{ duration: 1 }}
          animate={toggle ? 'open' : 'closed'}
          variants={{
            open: { height: 'auto' },
            closed: { height: '130px' },
          }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
      {renderButton()}
    </>
  );
};

export default SpecialCardAccordion;
